module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-100.8a7bd785.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-100.png
// module id = 3323
// module chunks = 11